import { BWIError } from './bwi-error';

export class BWIMissingInfo extends BWIError {
    constructor(bwiCode: string | undefined, optionId: number | undefined) {
        super(bwiCode);
        this.resultId = optionId == null ? null : optionId;
    }

    resultId: number | null;
}
